var _linearGradient, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderTimeout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "placeholder timeout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 175,
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cqosbad0qb",
    x1: 0.5,
    y1: 0.07,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "0mtdjg5kwa"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(502 267)",
    style: {
      fill: "red"
    },
    d: "M0 0h362v175H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe de masques 25",
    transform: "translate(-502 -267)",
    style: {
      clipPath: "url(#0mtdjg5kwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "bg card",
    d: "M152 0h58a152 152 0 0 1 152 152H0A152 152 0 0 1 152 0z",
    transform: "translate(502 290)",
    style: {
      fill: "url(#cqosbad0qb)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 226",
    transform: "translate(-501 -115)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 224",
    transform: "rotate(-30 400.14 287.872)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 267",
    d: "M5803.007 13149.471V13142h15v7.333a54.021 54.021 0 0 0-15 .139z",
    transform: "translate(-5129.984 -12841.801)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 268",
    d: "M0 0h15v1L0 4z",
    transform: "translate(673.022 300.082)",
    style: {
      fill: "#b1b1b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 327",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(668.523 294.198)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 328",
    width: 11.569,
    height: 3.5,
    rx: 1.75,
    transform: "translate(679.022 294.73)",
    style: {
      fill: "#d0d0d0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 231",
    transform: "rotate(30 962.368 293.32)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 267",
    d: "M5803.007 13149.471V13142h15v7.333a54.021 54.021 0 0 0-15 .139z",
    transform: "translate(-5129.984 -12841.801)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 268",
    d: "M15 0H0v.539L15 2z",
    transform: "translate(673.022 300.082)",
    style: {
      fill: "#b1b1b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 327",
    width: 24,
    height: 6,
    rx: 3,
    transform: "translate(668.523 294.198)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 328",
    width: 4.569,
    height: 3.5,
    rx: 1.75,
    transform: "translate(670.022 294.73)",
    style: {
      fill: "#d0d0d0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 223",
    transform: "translate(0 -152.588)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 269",
    d: "M5803.007 13149.471V13142h15v7.333a54.021 54.021 0 0 0-15 .139z",
    transform: "translate(-5129.006 -12841.883)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 320",
    width: 28,
    height: 22.408,
    rx: 6,
    transform: "translate(667.53 277.88)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 321",
    transform: "translate(674.03 300.288)",
    style: {
      fill: "#b1b1b1"
    },
    d: "M0 0h15v2.563H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 324",
    width: 18,
    height: 3.5,
    rx: 1.75,
    transform: "translate(671.03 280.288)",
    style: {
      fill: "#d0d0d0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 81",
    cx: 54,
    cy: 54,
    r: 54,
    transform: "translate(628 154)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Soustraction 9",
    d: "M5757.011 13197c0-.4-.007-.714-.007-1a53.759 53.759 0 0 1 9.222-30.193 54.153 54.153 0 0 1 23.758-19.564 53.929 53.929 0 0 1 51.21 4.979 54.149 54.149 0 0 1 19.566 23.76A53.668 53.668 0 0 1 5865 13196c0 .288 0 .605-.008.943a54 54 0 0 0-107.982.056z",
    transform: "translate(-5129 -12988)",
    style: {
      fill: "#d0d0d0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 232"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 74",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(633 159)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 270",
    d: "M16212 21305a50 50 0 1 1 50 50 50 50 0 0 1-50-50zm51 38.2v9.3a1 1 0 0 1-.123.488A47.941 47.941 0 0 0 16310 21305v-.145a1.026 1.026 0 0 1-.53.145h-9.293a1.031 1.031 0 0 1 0-2.062h9.293a1.006 1.006 0 0 1 .493.123 47.95 47.95 0 0 0-47.082-46.053 1 1 0 0 1 .123.492v8.26a1.032 1.032 0 1 1-2.063 0v-8.26a1.062 1.062 0 0 1 .123-.492 47.963 47.963 0 0 0-47.023 46.02 1.075 1.075 0 0 1 .435-.09h9.293a1.031 1.031 0 1 1 0 2.063h-9.293a1.072 1.072 0 0 1-.472-.111v.111a47.953 47.953 0 0 0 47.061 47.988 1 1 0 0 1-.123-.488v-9.3a1.032 1.032 0 0 1 2.063 0zm21.593 1.939-3.875-6.705a.245.245 0 0 1 .1-.348.261.261 0 0 1 .349.09l3.875 6.711a.258.258 0 0 1-.092.348.284.284 0 0 1-.128.033.265.265 0 0 1-.228-.125zm-46.112.1a.255.255 0 0 1-.1-.354l3.875-6.705a.252.252 0 0 1 .349-.09.259.259 0 0 1 .1.348l-3.875 6.705a.265.265 0 0 1-.226.129.25.25 0 0 1-.123-.034zm-12.021-40.752a35.543 35.543 0 1 1 35.538 35.537 35.541 35.541 0 0 1-35.537-35.538zm21.9-32.279a35.1 35.1 0 1 0 13.635-2.756 34.995 34.995 0 0 0-13.631 2.755zm14.808 61.049v-1.217a1.482 1.482 0 1 1 2.959 0v1.217a1.482 1.482 0 1 1-2.959 0zm.536-1.217v1.217c0 .734.354 1.088.943 1.088s.943-.354.943-1.088v-1.217c0-.725-.354-1.088-.943-1.088s-.939.362-.939 1.087zm-4.2 1.613.51-.076a.876.876 0 0 0 .916.768.783.783 0 0 0 .863-.789c0-.461-.333-.738-.917-.738h-.364v-.467h.364c.547 0 .8-.273.8-.691a.669.669 0 0 0-.751-.707.838.838 0 0 0-.868.787l-.514-.08a1.323 1.323 0 0 1 1.377-1.18 1.169 1.169 0 0 1 1.292 1.158 1.016 1.016 0 0 1-.574.938v.012a1.018 1.018 0 0 1 .7 1 1.287 1.287 0 0 1-1.42 1.238 1.314 1.314 0 0 1-1.406-1.174zm17.676-3.088.509-.086a.887.887 0 0 0 .916.762.872.872 0 0 0 .885-.959.826.826 0 0 0-.874-.906 1.06 1.06 0 0 0-.868.418h-.472l.252-2.342h2.219v.477H16278l-.139 1.27a1.365 1.365 0 0 1 .841-.277 1.309 1.309 0 0 1 1.34 1.371 1.386 1.386 0 0 1-1.446 1.432 1.337 1.337 0 0 1-1.408-1.161zm-27.768 0 .51-.086a.881.881 0 0 0 .911.762.87.87 0 0 0 .89-.959.827.827 0 0 0-.879-.906 1.061 1.061 0 0 0-.869.418h-.466l.252-2.342h2.224v.477h-1.763l-.145 1.27a1.382 1.382 0 0 1 .847-.277 1.3 1.3 0 0 1 1.334 1.371 1.38 1.38 0 0 1-1.436 1.432 1.336 1.336 0 0 1-1.402-1.161zm-3.612-.01.51-.076a.871.871 0 0 0 .916.762.783.783 0 0 0 .868-.783c0-.461-.338-.738-.922-.738h-.364v-.467h.364c.547 0 .8-.279.8-.691a.666.666 0 0 0-.75-.7.838.838 0 0 0-.868.783l-.515-.08a1.328 1.328 0 0 1 1.377-1.186 1.175 1.175 0 0 1 1.292 1.158 1 1 0 0 1-.573.938v.018a1.016 1.016 0 0 1 .7.99 1.288 1.288 0 0 1-1.42 1.244 1.319 1.319 0 0 1-1.407-1.172zm27.9 1.1v-.252c0-.658.268-1.076 1.211-1.666.782-.488.96-.789.96-1.152a.674.674 0 0 0-.734-.729c-.488 0-.863.311-.949.975l-.515-.08a1.4 1.4 0 0 1 1.447-1.373 1.194 1.194 0 0 1 1.292 1.223c0 .531-.263.938-1.142 1.475-.729.449-.965.713-1.013 1.1h2.181v.482zm27.9-3.334-6.715-3.869a.255.255 0 1 1 .257-.439l6.716 3.869a.266.266 0 0 1 .091.355.257.257 0 0 1-.22.123.224.224 0 0 1-.129-.042zm-80.139-.084a.267.267 0 0 1 .1-.355l6.71-3.869a.254.254 0 0 1 .349.092.251.251 0 0 1-.091.348l-6.705 3.869a.237.237 0 0 1-.134.039.271.271 0 0 1-.224-.127zm65.717-9.332v-1.211a1.484 1.484 0 1 1 2.964 0v1.211a1.484 1.484 0 1 1-2.964 0zm.536-1.211v1.211c0 .734.354 1.088.943 1.088s.942-.354.942-1.088v-1.211c0-.729-.354-1.088-.942-1.088s-.938.357-.938 1.085zm-4.068 2.707v-.252c0-.654.269-1.072 1.212-1.662.782-.488.964-.793.964-1.152a.683.683 0 0 0-.739-.734c-.487 0-.863.316-.948.98l-.515-.08a1.4 1.4 0 0 1 1.452-1.371 1.184 1.184 0 0 1 1.286 1.221c0 .531-.263.934-1.136 1.475-.734.445-.971.713-1.014 1.094h2.177v.482zm-45.576-1.6v-1.211a1.484 1.484 0 1 1 2.964 0v1.211a1.484 1.484 0 1 1-2.964 0zm.541-1.211v1.211c0 .734.354 1.088.943 1.088s.938-.354.938-1.088v-1.211c0-.734-.354-1.094-.938-1.094s-.939.359-.939 1.094zm-2.251 2.707v-.82h-2.036v-.43l1.908-2.953h.643v2.932h.584v.451h-.584v.82zm-1.484-1.271h1.484v-2.309zm53.7-15.311.51-.086a.907.907 0 0 0 1.8-.193.826.826 0 0 0-.874-.906 1.059 1.059 0 0 0-.874.424h-.466l.252-2.348h2.219v.477h-1.758l-.145 1.266a1.378 1.378 0 0 1 .847-.273 1.311 1.311 0 0 1 1.34 1.377 1.385 1.385 0 0 1-1.447 1.426 1.333 1.333 0 0 1-1.399-1.164zm-53.631 0 .509-.086a.909.909 0 0 0 1.806-.193.827.827 0 0 0-.879-.906 1.058 1.058 0 0 0-.873.424h-.467l.252-2.348h2.219v.477h-1.752l-.145 1.266a1.357 1.357 0 0 1 .847-.273 1.306 1.306 0 0 1 1.334 1.377 1.382 1.382 0 0 1-1.447 1.426 1.336 1.336 0 0 1-1.399-1.164zm52.056 1.088v-3.291h-.825v-.43h.182c.5 0 .665-.111.761-.477h.424v4.2zm-53.733 0v-.814h-2.042v-.43l1.908-2.953h.643v2.922h.579v.461h-.579v.814zm-1.49-1.275h1.49v-2.3zm6.309-12.605v-1.211a1.484 1.484 0 1 1 2.963 0v1.211a1.484 1.484 0 1 1-2.963 0zm.541-1.211v1.211c0 .729.354 1.082.943 1.082s.943-.354.943-1.082v-1.211c0-.734-.354-1.088-.943-1.088s-.939.353-.939 1.087zm-4.138 1.617.509-.086a.884.884 0 0 0 .911.762.874.874 0 0 0 .89-.959.822.822 0 0 0-.873-.906 1.067 1.067 0 0 0-.874.424h-.466l.252-2.348h2.224v.477h-1.763l-.145 1.271a1.384 1.384 0 0 1 .847-.279 1.31 1.31 0 0 1 1.345 1.371 1.39 1.39 0 0 1-1.452 1.432 1.337 1.337 0 0 1-1.401-1.16zm52.688-.424v-1.211a1.484 1.484 0 1 1 2.964 0v1.211a1.484 1.484 0 1 1-2.964 0zm.536-1.211v1.211c0 .73.354 1.084.943 1.084s.942-.354.942-1.084v-1.211c0-.734-.354-1.088-.942-1.088s-.938.353-.938 1.087zm-2.166 2.707v-3.291h-.819v-.434h.177c.509 0 .67-.107.767-.477h.418v4.2zm9.245-6.512a.26.26 0 0 1 .092-.348l6.71-3.869a.264.264 0 0 1 .354.09.261.261 0 0 1-.1.354l-6.71 3.875a.265.265 0 0 1-.129.027.251.251 0 0 1-.21-.129zm-66.526.1-6.7-3.875a.26.26 0 0 1-.106-.354.271.271 0 0 1 .358-.09l6.705 3.869a.26.26 0 0 1 .091.354.244.244 0 0 1-.22.123.267.267 0 0 1-.124-.026zm49.018-6.023.509-.086a.907.907 0 0 0 1.8-.193.828.828 0 0 0-.879-.91 1.05 1.05 0 0 0-.868.424h-.466l.252-2.348h2.219v.482h-1.758l-.146 1.264a1.387 1.387 0 0 1 .848-.277 1.305 1.305 0 0 1 1.334 1.377 1.381 1.381 0 0 1-1.441 1.426 1.332 1.332 0 0 1-1.4-1.158zm-29.954 0 .51-.086a.882.882 0 0 0 .911.762.872.872 0 0 0 .89-.955.828.828 0 0 0-.879-.91 1.054 1.054 0 0 0-.868.424h-.467l.252-2.348h2.219v.482h-1.758l-.145 1.264a1.382 1.382 0 0 1 .847-.277 1.31 1.31 0 0 1 1.34 1.377 1.385 1.385 0 0 1-1.447 1.426 1.333 1.333 0 0 1-1.401-1.158zm-3.542 0 .509-.086a.878.878 0 0 0 .911.762.868.868 0 0 0 .885-.955.824.824 0 0 0-.874-.91 1.048 1.048 0 0 0-.868.424h-.466l.252-2.348h2.219v.482h-1.759l-.145 1.264a1.386 1.386 0 0 1 .847-.277 1.305 1.305 0 0 1 1.335 1.377 1.385 1.385 0 0 1-1.447 1.426 1.327 1.327 0 0 1-1.395-1.158zm17.659-4.533v-1.217a1.484 1.484 0 1 1 2.964 0v1.217a1.484 1.484 0 1 1-2.964 0zm.541-1.217v1.217c0 .729.354 1.082.943 1.082s.943-.354.943-1.082v-1.217c0-.734-.359-1.084-.943-1.084s-.939.35-.939 1.085zm18.822-2.311a.245.245 0 0 1-.1-.344l3.875-6.709a.263.263 0 0 1 .354-.1.255.255 0 0 1 .092.35l-3.875 6.709a.256.256 0 0 1-.22.135.227.227 0 0 1-.122-.04zm-38.556-.092-3.875-6.7a.257.257 0 1 1 .445-.258l3.875 6.709a.263.263 0 0 1-.1.35.294.294 0 0 1-.129.037.244.244 0 0 1-.211-.137z",
    transform: "translate(-15580.001 -21096.998)",
    style: {
      fill: "#b1b1b2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 229"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "shadow red",
    d: "m5766.022 13186.5-3.361.129v-4l3.361.13a5 5 0 0 1 9.406.361l39.232 1.509-39.232 1.511a5 5 0 0 1-9.406.362z",
    transform: "rotate(-109.01 -1401.171 8512)",
    style: {
      opacity: 0.087
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "shadow black",
    d: "m5755.169 13186.293-3.168.084v-2.755l3.168.084a5 5 0 0 1 9.723.258L5804 13185l-39.105 1.035a5 5 0 0 1-9.724.258z",
    transform: "rotate(-92 -3045.398 9151.199)",
    style: {
      opacity: 0.085
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 24",
    d: "m5766.022 13186.5-3.361.129v-4l3.361.13a5 5 0 0 1 9.406.361l39.232 1.509-39.232 1.511a5 5 0 0 1-9.406.362z",
    transform: "rotate(-105.01 -1751.828 8649.596)",
    style: {
      fill: "#b51218"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 23",
    d: "m5755.169 13186.293-3.168.084v-2.755l3.168.084a5 5 0 0 1 9.723.258L5804 13185l-39.105 1.035a5 5 0 0 1-9.724.258z",
    transform: "rotate(-90 -3265.407 9237.415)",
    style: {
      fill: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 78 - Contour",
    d: "M2.751 1.375a1.375 1.375 0 1 0 1.375 1.376 1.377 1.377 0 0 0-1.375-1.376m0-1.375A2.751 2.751 0 1 1 0 2.751 2.751 2.751 0 0 1 2.751 0z",
    transform: "rotate(-105.01 420.544 -154.498)",
    style: {
      fill: "#a89985"
    }
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 330",
    width: 68,
    height: 2,
    rx: 1,
    transform: "translate(147 173)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderTimeout);
export default __webpack_public_path__ + "static/media/placeholder-timeout.eb64baea41c4c097dc4913c31860e91f.svg";
export { ForwardRef as ReactComponent };